import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ENTER } from '@angular/cdk/keycodes';
import { debounceTime } from 'rxjs/operators';
import { CommonModelService } from '../../../../padu-reporting/capability/common-model.service';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-edit-role-popup',
    templateUrl: './edit-role-popup.component.html',
    styleUrl: './edit-role-popup.component.css',
    standalone: false
})
export class EditRolePopupComponent {

  @Input() selectedInitiative: any;
  @Input() clearFormFields: boolean = false;
  @Input() elementData: any;
  @Input() dataSource: any;
  @Output() editSuccessEvent: EventEmitter<any> = new EventEmitter();
  @ViewChild('inputEditUser') inputEditUser: any;
  @Output() closeModal = new EventEmitter<void>();
  @Input() reloadData: any;
  private subject: Subject<string> = new Subject();
  masterSegment: any;
  lob: any;
  subLobName: any;
  role: any;
  lobData = [];
  segmentData = [];
  roleDropdownList = [];
  selectedUsers = [];
  users: any = [];
  inputElement: any;
  separatorKeysCodes: number[] = [ENTER];
  removedUsers = [];
  addedUsers = [];

  constructor(
    private capabilityService: CommonModelService) { }

  ngOnChanges() {
    if (this.elementData && Object.keys(this.elementData).length != 0) {
      this.masterSegment = (this.elementData && this.elementData.MasterSegment) ? this.elementData.MasterSegment : '';
      this.lob = (this.elementData && this.elementData.CIOLOB) ? this.elementData.CIOLOB : '';
      this.subLobName = (this.elementData && this.elementData.Sub_LOB) ? this.elementData.Sub_LOB : '';
      this.role = (this.elementData && this.elementData.role) ? this.elementData.role : '';
      this.selectedUsers = this.elementData && this.elementData.users ? [...this.elementData.users] : [];
    }
  }

  ngOnInit() {
    this.subject.pipe(
      debounceTime(500)
    ).subscribe(searchObj => {
      this.handleSearch(searchObj);
    });
  }

  handleSearch(searchObj) {
    const value = searchObj['search'];
    const column = searchObj['column'];
    if (value) {
      this.capabilityService.getLDAPUsers(value).subscribe(dataStream => {
        this.users = [];
        dataStream.forEach(element => {
          this.users.push({
            givenName: element.givenName,
            sn: element.sn,
            mail: element.mail,
            displayName: element.displayName,
            employeeID: element.employeeID,
            MSId: element.cn,
            middleName: element.middleName,
          });
        });
      }, (error) => {
        console.error(error);
      });
    } else {
      column.options = [];
    }
  }

  keyUpSearch(name) {
    const p: any = {}
    p['search'] = name.target.value;
    this.inputElement = name;
    if (name.target.value) {
      this.subject.next(p);
    }
    else {
      this.users = [];
    }
  }

  resetFields() {
    this.addedUsers = [];
    this.removedUsers = [];
  }

  removeSubLobUsers(user) {
    const index = this.selectedUsers.indexOf(user);
    if (index >= 0) {
      this.selectedUsers.splice(index, 1);
      this.removedUsers.push(user);
    }
  }

  AddUsers(event) {
    this.addedUsers.push(event.option.value);
    this.addedUsers = this.addedUsers.filter((value, index, self) => index === self.findIndex((obj) => obj.MSId === value.MSId));
    this.selectedUsers.push(event.option.value);
    if (this.inputElement) {
      this.inputElement.target.value = '';
      this.users = []
    }
  }

  submitEditRole() {
    if (!this.selectedUsers.length) {
      return;
    }
    const payload = {
      'element': this.elementData,
      'add': this.addedUsers,
      'remove': this.removedUsers
    }
    this.resetFields();
    this.editSuccessEvent.emit(payload);
  }


  checkexistArchitects(user) {
    let tempVar = [];
    tempVar = this.selectedUsers;
    let tempBool = false
    tempVar.forEach(archi => {
      if (user.MSId === archi.msid || user.MSId === archi.MSId) {
        tempBool = true;
      }

    });
    return tempBool;
  }

  focusOnInput() {
    this.inputEditUser.nativeElement.focus();
  }
}

